import {sxhr,} from 'fire-wind-water/sxhr';
import {$subscriber} from 'fire-wind-water';
let staticUrl = '';
if(window.config && window.config.apiCacheUrl){
    staticUrl = window.config.apiCacheUrl;
}
class ThirdAnanly {
    constructor() {
        this.postUrl = '';
        this.tenantId = '';
    }
    getThirdanaly(){
        var _self = this;
        sxhr.post(`${this.postUrl}/api/account/thirdanalytics/get`, {tenantId: this.tenantId}).then(function (e){
            var data = e.data.body;
            if(data.result == 0){
                if(data.content&&data.content.items&&data.content.items.length>0){
                    data.content.items.forEach(function (d){
                        if(d['thirdConfigValue']){
                            _self.createDom(d['thirdName'],d['thirdConfigValue']);
                        }
                    });
                }
            }
        }, function (){
        });
    }
    init(){
        var _self = this;
        if(staticUrl){
            sxhr.get(`${staticUrl}${this.tenantId}/thirdanalytics.json?v=${Math.random()}`).then(function(e) {
                var data = e.data.body;
                if(data.result == 0){
                    if(data.content&&data.content.items&&data.content.items.length>0){
                        data.content.items.forEach(function (d){
                            if(d['thirdConfigValue']){
                                _self.createDom(d['thirdName'],d['thirdConfigValue']);
                            }
                        });
                    }
                }
            }, function(){
                _self.getThirdanaly();
            });
        }else{
            _self.getThirdanaly();
        }


    }
    createDom(type, id){
        switch (type){
            case 'ga':
                var ga = document.getElementById('ga');
                if(!ga){
                    var gaNode = document.createDocumentFragment();
                    var gaUrl = document.createElement('script');
                    gaUrl.type = "text/javascript";
                    gaUrl.async = true;
                    gaUrl.id = 'ga';
                    gaUrl.src = 'https://www.googletagmanager.com/gtag/js?id='+id;
                    gaNode.appendChild(gaUrl);
                    var gaScript = document.createElement('script');
                    gaScript.type = "text/javascript";
                    gaScript.appendChild(document.createTextNode(`window.dataLayer = window.dataLayer || []; function gtag(){window.dataLayer.push(arguments);} gtag("js",new Date()); gtag("config","${id}");`));
                    gaNode.appendChild(gaScript);
                    document.head.appendChild(gaNode);
                }
                break;
            case 'baidu':
                var baidu = document.getElementById('baidu');
                if(!baidu) {
                    var baiduScript = document.createElement('script');
                    baiduScript.id = 'baidu';
                    baiduScript.appendChild(document.createTextNode(`var _hmt = _hmt || []; (function(){var hm = document.createElement('script');hm.src = "https://hm.baidu.com/hm.js?${id}";var s = document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm,s);})();`));
                    document.head.appendChild(baiduScript);
                }
                break;
            case 'cnzz':
                var cnzz = document.getElementById('cnzz');
                if(!cnzz) {
                    var cnzzScript = document.createElement('script');
                    cnzzScript.id = 'cnzz';
                    cnzzScript.type = "text/javascript";
                    cnzzScript.src = `https://v1.cnzz.com/z_stat.php?id=${id}&web_id=${id}`;
                    document.head.appendChild(cnzzScript);
                }
                break;
        }
    }
    setUrl(url){
        this.postUrl = url;
        if(this.tenantId) {
            thirdAnanly.init();
        }
    }
    watch(){
        var  self = this;
        $subscriber.subscribe('jsonParams',function (content){
            self.tenantId = content.tenantId;
            if(self.postUrl){
                self.init();
            }
        });
    }

}
const thirdAnanly = new ThirdAnanly();
export {
    thirdAnanly
};
